/**
 * save-report-schema-response.ts
 * Copyright (c) 2016-2017, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { AggregatorDescriptor }
  from "../../../aggregation/aggregator-descriptor";
import { validateAs, validateFor, validateOpaqueID }
  from "../../validation/decorators";
import { IncomingMessage } from "../general/incoming-message";
import { MessageTag } from "../message-tag";

@validateFor(MessageTag.RSP_SAVE_REPORT_SCHEMA)
export class SaveReportSchemaResponse extends IncomingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.RSP_SAVE_REPORT_SCHEMA;

  @validateOpaqueID()
  public schemaId : number;
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/schemas/save-report-schema-response.ts